import {JsonProperty} from 'json-typescript-mapper';
import {Contact} from '../../entities/contact.model';
export class User {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('login')
  public login?: string;

  @JsonProperty('firstName')
  public firstName?: string;

  @JsonProperty('lastName')
  public lastName?: string;

  @JsonProperty('email')
  public email?: string;

  @JsonProperty('activated')
  public activated?: Boolean;

  @JsonProperty('langKey')
  public langKey?: string;

  @JsonProperty('authorities')
  public authorities?: any[];

  @JsonProperty('createdBy')
  public createdBy?: string;

  @JsonProperty({clazz: Date, name: 'createdDate'})
  public createdDate?: Date;

  @JsonProperty('lastModifiedBy')
  public lastModifiedBy?: string;

  @JsonProperty({clazz: Date, name: 'lastModifiedDate'})
  public lastModifiedDate?: Date;

  @JsonProperty('password')
  public password?: string;

  @JsonProperty({clazz: Contact, name: 'contact'})
  public contact?: Contact;
    constructor(
        id?: any,
        login?: string,
        firstName?: string,
        lastName?: string,
        email?: string,
        activated?: Boolean,
        langKey?: string,
        authorities?: any[],
        createdBy?: string,
        createdDate?: Date,
        lastModifiedBy?: string,
        lastModifiedDate?: Date,
        password?: string
    ) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.firstName = firstName ? firstName : null;
        this.lastName = lastName ? lastName : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
        this.contact = void 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.model.ts